import './style.scss'

import TeamCampaignStatistics from 'components/molecules/TeamCampaignStatistics'
import { TeamSideId } from 'features/team/const'
import { teamHooks } from 'features/team/index.ts'
import { Navigate } from 'react-router-dom'
import { leftSideHooks } from 'shared/hooks'

import { useLegacyPersonas } from '../useLegacyPersonas'
import { useTempProps } from './temp'

export function StatisticsPage() {
	const showMembers = teamHooks.useIsEnable()

	return showMembers ? <Inner /> : <Navigate to='/team/members' />
}

function Inner() {
	const [personas, { isLoading }] = useLegacyPersonas()

	leftSideHooks.useActive(TeamSideId.Statistics)

	const tempProps = useTempProps()

	return (
		<TeamCampaignStatistics
			archive={false}
			{...tempProps}
			loader={isLoading}
			personas={personas}
		/>
	)
}
